import React from 'react';
import '../../styles/components/GlassmorphismCard.css';

// isShown => to show view details button on hover effect when user hovers over the card
// onViewDetails => function to view details of the card by navigating user to EventDetailPage when user clicks on view details button or any where in card
export default function GlassmorphismCard({ isShown, onViewDetails }) {
    return (
        <div
            className={`glassmorphism-card-container ${isShown ? 'shown' : ''}`}
            onClick={onViewDetails}
        >
            <div className="glassmorphism-card-view-more">
                <button>View Details</button>
            </div>
        </div>
    );
}
